<template>
    <div class="vendor-ranking">
        <Title :img="triangleImg" :name="'服务商排名'" :callback="getProviderList" />
        <div class="vendor-content">
            <div class="ranking-list">
                <div v-for="(provider, index) in sortedProviders" :key="provider.id" class="ranking-item"
                    :style="{ '--delay': `${index * 0.1}s` }">
                    <div class="rank-number">{{ index + 1 }}</div>
                    <div class="provider-info">
                        <div class="provider-name">{{ provider.name }}</div>
                        <div class="progress-bar">
                            <div class="progress" :style="{ width: `${provider.rating}%` }"></div>
                        </div>
                    </div>
                    <div class="rating">{{ provider.rating }}分</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Title from '@/components/title/title.vue'
import triangleImg from '@/assets/image/triangle.png'
export default {
    name: 'VendorRanking',
    components: { Title },
    data() {
        return {
            triangleImg: triangleImg,
            serviceProviders: [
                {
                    id: 'SP-INF-001',
                    name: '迅捷管道工程',
                    rating: 92
                },
                {
                    id: 'SP-SAN-002',
                    name: '绿净环境服务',
                    rating: 88
                },
                {
                    id: 'SP-LAN-003',
                    name: '四季园林',
                    rating: 95
                },
                {
                    id: 'SP-PAR-004',
                    name: '安泊智能',
                    rating: 90
                },
                {
                    id: 'SP-COM-005',
                    name: '园区万事达',
                    rating: 85
                }
            ]
        }
    },
    computed: {
        sortedProviders() {
            return [...this.serviceProviders].sort((a, b) => b.rating - a.rating)
        }
    },
    methods: {
        getProviderList() {
            this.$router.push({ path: "/vendor-manage" });
        }
    }
}
</script>

<style lang="less" scoped>
.vendor-ranking {
    position: relative;
    height: 30%;
    width: 100%;
    border-radius: 5px;
    padding: 0.5rem;
    background:
        /* 左上角圆形渐变 */
        radial-gradient(circle at left top, #c8aca2, #171e2127 5%) no-repeat,
        /* 右上角圆形渐变 */
        radial-gradient(circle at right top, #c8aca2, #171e2127 5%) no-repeat,
        /* 中间半透明背景 */
        linear-gradient(to bottom, #171e2127, #171e2127);

    .vendor-content {
        height: calc(100% - 2rem);
        width: 100%;
        overflow: auto;

        .ranking-list {
            height: 100%;
            padding: 0.5rem;
            display: flex;
            flex-direction: column;
            gap: 0.8rem;

            .ranking-item {
                display: flex;
                align-items: center;
                gap: 1rem;
                color: #fff;
                animation: slideIn 0.5s ease-out forwards;
                animation-delay: var(--delay);
                opacity: 0;
                transform: translateX(-20px);

                .rank-number {
                    width: 1rem;
                    height: 1rem;
                    background: linear-gradient(135deg, #188df0, #0056b3);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 0.9rem;
                }

                .provider-info {
                    flex: 1;

                    .provider-name {
                        font-size: 0.8rem;
                        margin-bottom: 0.3rem;
                        color: #eee;
                    }

                    .progress-bar {
                        height: 0.4rem;
                        background: rgba(255, 255, 255, 0.1);
                        border-radius: 2px;
                        overflow: hidden;

                        .progress {
                            height: 100%;
                            background: linear-gradient(90deg, #188df0, #64b5f6);
                            border-radius: 2px;
                            transition: width 0.8s ease-out;
                        }
                    }
                }

                .rating {
                    min-width: 3.5rem;
                    font-size: 1rem;
                    font-weight: bold;
                    color: #64b5f6;
                }

                &:nth-child(1) {
                    .rank-number {
                        background: linear-gradient(135deg, #ffd700, #ffa000);
                    }

                    .rating {
                        color: #ffd700;
                    }
                }

                &:nth-child(2) {
                    .rank-number {
                        background: linear-gradient(135deg, #c0c0c0, #9e9e9e);
                    }

                    .rating {
                        color: #c0c0c0;
                    }
                }

                &:nth-child(3) {
                    .rank-number {
                        background: linear-gradient(135deg, #cd7f32, #8d6e63);
                    }

                    .rating {
                        color: #cd7f32;
                    }
                }
            }
        }
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>